export default __webpack_public_path__ + "static/media/home-business-slider-img01.8ac01949.jpg";